<template>
  <div class="help-icon-container">
    <v-menu
      v-model="menuOpen"
      :close-on-content-click="false"
      class="help-pos"
      max-width="190"
      min-width="190"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on" size="24" class="material-icons-round" @click="debugClick">
          mdi-help-circle-outline
        </v-icon>
      </template>

      <v-card class="help-menu-card">
        <v-list class="pa-0">
          <v-list-item class="v-list-item" v-for="item in config" :key="item.title">
            <v-list-item-content class="pt-4 pb-4">
              <v-list-item-title class="text-left">
                <div class="text-uppercase mb-1 mt-1 pl-1 font-weight-bold title-text-color">
                  {{ config.sections[0].title }}
                </div>
              </v-list-item-title>
              <div class="pl-1" v-if="config.sections[0].requestLink !== undefined">
                <a v-bind:href="config.sections[0].requestLink.href" target="_blank">{{
                  config.sections[0].requestLink.label
                }}</a>
              </div>
              <v-list-item
                class="pl-1 pb-2"
                v-for="link in config.sections[0].links"
                :key="link.label"
              >
                <a href="#" @click.prevent="openSupportEmail(link)">{{ link.label }}</a>
              </v-list-item>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      menuOpen: false,
    };
  },
  watch: {
    menuOpen(newVal) {
      console.log("Menu open changed to:", newVal);
    },
  },
  methods: {
    debugClick() {
      this.menuOpen = !this.menuOpen;
    },
    openSupportEmail(link) {
      // Use Office.js API to open a new message form in Outlook
      if (window.Office && Office.context && Office.context.mailbox && Office.context.mailbox.displayNewMessageForm) {
        Office.context.mailbox.displayNewMessageForm({
          toRecipients: [link.href],
          subject: link.subject || '',
          htmlBody: link.body || ''
        });
      } else {
        // Fallback: open mailto if Office.js is not available
        window.location.href = 'mailto:' + link.href;
      }
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 320px) {
  .help-icon-container {
    margin-right: 32px !important;
  }
  .help-menu-card{
   top: -8px!important;
    left: 24px!important;
  }
}

.help-pos {
  top: 40px !important;
  right: 210px !important;
  left: auto !important;
}
.help-icon-container {
  cursor: pointer;
  z-index: 400;
}

.v-list-item {
  min-height: 10px !important;
  font-size: small !important;
}

a {
  color: #003f2d !important;
  text-decoration: underline solid transparent;
  -webkit-text-decoration-color: #17e88f;
  text-decoration-color: #17e88f;
}

a:hover {
  -webkit-text-decoration-color: #1a1a1a;
  text-decoration-color: #1a1a1a;
}

.title-text-color {
  color: #1a1a1a !important;
}

* {
  font-family: "Calibre", sans-serif;
}
</style>
